export default __webpack_public_path__ + "static/media/Sage's Coverings of the Eldritch.5f04b43e.jpg";